import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormControl, InputLabel, InputAdornment, OutlinedInput, FormControlLabel, Checkbox, Autocomplete,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import PageTitle from "../components/PageTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {RemoveRedEye} from "@mui/icons-material";
import copyObject from "../utils/copyObject";
import Paper from "@mui/material/Paper";
import {
    useLazySessionResultsAtTheMomentOfPassingByEmployeesWebReportQuery,
    useLazySessionResultsAtTheMomentOfPassingByFacultyGroupsWebReportQuery
} from "../store/reports/reportsApi";
import {useGetFacultiesQuery} from "../store/faculty/facultyApi";
import {useGetSemestersQuery} from "../store/system/systemApi";
import {useListEmployeePersonsQuery} from "../store/employee/employeeApi";

export default function SessionResultsAtTheMomentOfPassingByEmployeeWebReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const {data: semestersData} = useGetSemestersQuery();
    const {data: personsData} = useListEmployeePersonsQuery();
    const [dataRequest] = useLazySessionResultsAtTheMomentOfPassingByEmployeesWebReportQuery();
    const [data, setData] = useState([]);
    const [semesterId, setSemesterId] = useState(null);
    const [personMasterGuid, setPersonMasterGuid] = useState(null);
    const [useIntramuralForm, setUseIntramuralForm] = useState(true);
    const [useExtramuralForm, setUseExtramuralForm] = useState(true);
    const [useIntramuralExtramuralForm, setUseIntramuralExtramuralForm] = useState(true);
    const [personsOptions, setPersonsOptions] = useState([]);
    
    useEffect(() => {
        if (personsData) {
            let personsOptionsData = [];
            personsData?.data?.forEach((item) => {
                personsOptionsData.push({
                    label: `${item.value} (${item.chairs.join(', ')})`,
                    value: item.key
                });
            });
            personsOptionsData = personsOptionsData.sort((l,r) => l.label > r.label ? 1 : -1);
            personsOptionsData.unshift({
                'label': 'Все сотрудники',
                'value': null
            });
            
            setPersonsOptions(personsOptionsData);
        }
    }, [personsData]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date) {
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const loadData = async () => {
        if (semesterId === null || semesterId === undefined) {
            alert('Выберите семестр')
            return;
        }
        
        setIsSaving(true);

        const request = {
            semesterId,
            personMasterGuid,
            addIntramuralForm: useIntramuralForm,
            addExtramuralForm: useExtramuralForm,
            addIntramuralExtramuralForm: useIntramuralExtramuralForm
        };
        console.log(request);

        await dataRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setData(copyObject(fulfilled.faculties))
            } else {
                fulfilled.errors?.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch((e) => {
            alert('Ошибка');
            setIsSaving(false);
        });
    };

    function avg(faculty, prop) {
        if (faculty.groups.length === 0)
            return 0;

        let sum = 0;
        faculty.groups.forEach((item) => {
            sum += item[prop];
        })

        return (sum / faculty.groups.length).toFixed(2);
    }

    function sum(faculty, prop) {
        let sum = 0;
        faculty.groups.forEach((item) => {
            sum += item[prop];
        })

        return sum;
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Результаты сессии на момент ее сдачи (По преподавателям)`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {isSaving ? <CircularProgress/> : <></>}
                            Результаты сессии на момент ее сдачи (По преподавателям)
                        </Typography>
                    </Stack>

                    <Box>
                        {/* Фильтр */}
                        <Card>
                            <CardContent>
                                <Stack spacing={2}>
                                    <Stack spacing={2} direction={'row'}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label" size={'small'}>Семестр</InputLabel>
                                            <Select size={'small'}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Семестр"
                                                    onChange={(event) => {setSemesterId(parseInt(event.target.value, 10))}}
                                            >
                                                {semestersData?.data.map((item) => {
                                                    return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                                })}
                                            </Select>
                                        </FormControl>

                                        <FormControl fullWidth>
                                            <Autocomplete
                                                size={'small'}
                                                options={personsOptions}
                                                renderInput={(params) => <TextField {...params} label="Преподаватель" />}
                                                onChange={(event: any,selectedCourseFilter) => {
                                                    console.log(selectedCourseFilter);
                                                    setPersonMasterGuid(selectedCourseFilter?.value);
                                                }}
                                            />
                                        </FormControl>
                                    </Stack>

                                    <Stack spacing={2} direction={'row'}>
                                        <FormControlLabel control={<Checkbox defaultChecked onChange={(event, checked) => {setUseExtramuralForm(checked)}} />} label="Заочная ф.о." />
                                        <FormControlLabel control={<Checkbox defaultChecked onChange={(event, checked) => {setUseIntramuralForm(checked)}}/>} label="Очная ф.о." />
                                        <FormControlLabel control={<Checkbox defaultChecked onChange={(event, checked) => {setUseIntramuralExtramuralForm(checked)}}/>} label="Очно-Заочная ф.о." />
                                    </Stack>
                                    
                                    <Button size={'small'} variant={'contained'} onClick={loadData}>Загрузить</Button>
                                </Stack>
                            </CardContent>
                        </Card>

                        <br/>

                        {/* Таблицы */}
                        {data?.sort((l,r) => l.facultyName > r.facultyName ? 1 : -1).map((faculty, index) => {
                            return <Box mb={4}>
                                <Typography variant="h6" gutterBottom>
                                    Преподаватель {faculty.facultyName}
                                </Typography>

                                <Card>
                                    <TableContainer>
                                        <Table size={'small'}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell rowSpan={2}>Группа</TableCell>
                                                    <TableCell rowSpan={2} align={'center'}>Всего человек</TableCell>
                                                    <TableCell colSpan={2} align={'center'}>"2"</TableCell>
                                                    <TableCell colSpan={2} align={'center'}>"н/я"</TableCell>
                                                    <TableCell colSpan={2} align={'center'}>"н/д"</TableCell>
                                                    <TableCell colSpan={2} align={'center'}>Всего не сдавших</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align={'center'}>Абс.</TableCell>
                                                    <TableCell align={'center'}>%</TableCell>

                                                    <TableCell align={'center'}>Абс.</TableCell>
                                                    <TableCell align={'center'}>%</TableCell>

                                                    <TableCell align={'center'}>Абс.</TableCell>
                                                    <TableCell align={'center'}>%</TableCell>

                                                    <TableCell align={'center'}>Абс.</TableCell>
                                                    <TableCell align={'center'}>%</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {faculty.groups.sort((l,r) => l.groupName > r.groupName ? 1 : -1).map((group) => {
                                                    return <>
                                                        <TableRow>
                                                            <TableCell>{group.groupName}</TableCell>
                                                            <TableCell align={'center'}>{group.numberOfStudentsInGroup}</TableCell>
                                                            <TableCell align={'center'}>{group.numberOfStudentsWithBadGrade}</TableCell>
                                                            <TableCell align={'center'}>{group.percentageOfStudentsWithBadGrade}%</TableCell>
                                                            <TableCell align={'center'}>{group.numberOfStudentsWithNotAppearedGrade}</TableCell>
                                                            <TableCell align={'center'}>{group.percentageOfStudentsWithNotAppearedGrade}%</TableCell>
                                                            <TableCell align={'center'}>{group.numberOfStudentsWithNotAllowedGrade}</TableCell>
                                                            <TableCell align={'center'}>{group.percentageOfStudentsWithNotAllowedGrade}%</TableCell>
                                                            <TableCell align={'center'}>{group.numberOfNotPassedStudents}</TableCell>
                                                            <TableCell align={'center'}>{group.percentageOfNotPassedStudents}%</TableCell>
                                                        </TableRow>
                                                    </>
                                                })}
                                                
                                                <TableRow style={{'backgroundColor': 'lightGray'}}>
                                                    <TableCell><strong>По преподавателю</strong></TableCell>
                                                    <TableCell align={'center'}>{sum(faculty, 'numberOfStudentsInGroup')}</TableCell>
                                                    <TableCell align={'center'}>{sum(faculty, 'numberOfStudentsWithBadGrade')}</TableCell>
                                                    <TableCell align={'center'}>{avg(faculty, 'percentageOfStudentsWithBadGrade')}%</TableCell>
                                                    <TableCell align={'center'}>{sum(faculty, 'numberOfStudentsWithNotAppearedGrade')}</TableCell>
                                                    <TableCell align={'center'}>{avg(faculty, 'percentageOfStudentsWithNotAppearedGrade')}%</TableCell>
                                                    <TableCell align={'center'}>{sum(faculty, 'numberOfStudentsWithNotAllowedGrade')}</TableCell>
                                                    <TableCell align={'center'}>{avg(faculty, 'percentageOfStudentsWithNotAllowedGrade')}%</TableCell>
                                                    <TableCell align={'center'}>{sum(faculty, 'numberOfNotPassedStudents')}</TableCell>
                                                    <TableCell align={'center'}>{avg(faculty, 'percentageOfNotPassedStudents')}%</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Card>
                            </Box>
                        })}
                    </Box>

                    <br/>
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
